import oAuthServiceConfig from "./oAuthServiceConfig";
import { Buffer } from "buffer";
import axios from "axios";
import FuseUtils from "@fuse/utils/FuseUtils";
import jwtDecode from "jwt-decode";
/* eslint-disable camelcase */

class OAuthService extends FuseUtils.EventEmitter {
  clearSessionPreserveTheme = () => {
    const savedTheme = localStorage.getItem("fuseSelectedTheme");
    localStorage.clear();
    if (savedTheme) {
      localStorage.setItem("fuseSelectedTheme", savedTheme);
    }
  };
  init() {
    this.setInterceptors();

    const isScreenUrl = window.location.pathname.includes('/dashboard/screen');
    const isUnlocked = sessionStorage.getItem('dashboard_unlocked') === 'true';
    if (isScreenUrl && isUnlocked) {
      this.signInWithClientCredentials();
      return;
    }

    const token = localStorage.getItem("access_token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const isRobotToken = decoded.scope && decoded.scope.includes("ROLE_DASHBOARDSCREEN");

        if (isRobotToken) {
          if (!isScreenUrl) {
            console.log("Robot token detected on normal page. Clearing session...");
            this.clearSessionPreserveTheme();
            window.location = "/redirect";
          }
        }
      } catch (error) {
        console.error("Invalid token detected", error);
        this.clearSessionPreserveTheme();
      }
    }
  }

  getRefreshBody = () => {
    const formData = new FormData();

    formData.append(
      oAuthServiceConfig.grantType,
      process.env.REACT_APP_OAUTH_REFRESH_GRANT_TYPE
    );
    formData.append(
      oAuthServiceConfig.refreshToken,
      localStorage.getItem("refresh_token")
    );
    return formData;
  };

  setInterceptors = () => {
    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      async (error) => {
        if (error.response?.status === 401) {

          const isScreenUrl = window.location.pathname.includes('/dashboard/screen');
          const isUnlocked = sessionStorage.getItem('dashboard_unlocked') === 'true';
          if (isScreenUrl && isUnlocked) {
            const success = await this.signInWithClientCredentials();
            if (success) {
              const newToken = localStorage.getItem("access_token");
              error.config.headers["Authorization"] = "Bearer " + newToken;
              return axios.request(error.config);
            }
          }

          if (localStorage.getItem("token")) {
            try {
              const response = await fetch(
                `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.token}`,
                {
                  // const response = await fetch(`${process.env.REACT_APP_OAUTH_REDIRECTC_URI}${oAuthServiceConfig.token}`, {

                  method: "POST",
                  headers: {
                    Authorization:
                      "Basic " +
                      Buffer.from(
                        process.env.REACT_APP_OAUTH_CLIENT_NAME +
                        ":" +
                        process.env.REACT_APP_OAUTH_CLIENT_SECRET
                      ).toString("base64"),
                  },
                  mode: "cors",
                  body: this.getRefreshBody(),
                }
              );
              const token = await response.json();
              if (token.id_token) {
                localStorage.setItem("token", token.id_token);
                localStorage.setItem("access_token", token.access_token);
                localStorage.setItem("refresh_token", token.refresh_token);
                error.config.headers["Authorization"] =
                  "Bearer " + token.id_token;
                return axios.request(error.config);
              } else {
                // const tokenDecode = jwtDecode(localStorage.getItem('token'))
                //const currentUrl = localStorage.getItem('currentUrl') ? {...JSON.parse(localStorage.getItem('currentUrl')), [tokenDecode.email]: window.location.pathname} : {} ;
                this.clearSessionPreserveTheme();
                //localStorage.setItem('currentUrl', JSON.stringify(currentUrl))
                window.location = "/redirect";
              }
            } catch (error) {
              console.log("error: ", error);
              //const token = jwtDecode(localStorage.getItem('token'))
              //const currentUrl = localStorage.getItem('currentUrl') ? {...JSON.parse(localStorage.getItem('currentUrl')), [token.email]: window.location.pathname} : {} ;
              this.clearSessionPreserveTheme();
              //localStorage.setItem('currentUrl', JSON.stringify(currentUrl))
              window.location = "/redirect";
            }
          } else {
            if (!isScreenUrl) {
              window.location = "/redirect";
            }
          }
        }

        throw error;
      }
    );
  };

  config = () => {
    // const header = new Headers();
    const header = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
    };
    return header;
  };
  configPdf = () => {
    // const header = new Headers();
    const header = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        Accept: "application/pdf",
      },
      responseType: "blob",
    };
    return header;
  };

  configDownload = () => {
    const header = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        Accept: "application/octet-stream",
      },
      responseType: "blob",
    };
    return header;
  };

  authorize = (codeChallenge) => {
    return `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.authorize}${process.env.REACT_APP_OAUTH_REDIRECTC_URI}&code_challenge=${codeChallenge}&code_challenge_method=S256`;
  };

  getBody = () => {
    const formData = new FormData();

    formData.append(
      oAuthServiceConfig.clientId,
      process.env.REACT_APP_OAUTH_CLIENT_NAME
    );
    formData.append(
      oAuthServiceConfig.redirectUri,
      process.env.REACT_APP_OAUTH_REDIRECTC_URI
    );
    formData.append(
      oAuthServiceConfig.grantType,
      process.env.REACT_APP_OAUTH_GRANT_TYPE
    );
    formData.append(oAuthServiceConfig.code, localStorage.getItem("code"));
    formData.append(
      oAuthServiceConfig.codeVerifier,
      localStorage.getItem("code_verifier")
    );
    return formData;
  };

  authenticate = async () => {
    try {
      const header = new Headers();
      header.set(
        "Authorization",
        "Basic " +
        Buffer.from(
          process.env.REACT_APP_OAUTH_CLIENT_NAME +
          ":" +
          process.env.REACT_APP_OAUTH_CLIENT_SECRET
        ).toString("base64")
      );
      const response = await fetch(
        `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.token}`,
        {
          method: "POST",
          headers: {
            Authorization:
              "Basic " +
              Buffer.from(
                process.env.REACT_APP_OAUTH_CLIENT_NAME +
                ":" +
                process.env.REACT_APP_OAUTH_CLIENT_SECRET
              ).toString("base64"),
          },
          mode: "cors",
          body: this.getBody(),
        }
      );
      if (response.status === 200) {
        const token = await response.json();
        if (token.id_token) {
          localStorage.setItem("token", token.id_token);
          localStorage.setItem("access_token", token.access_token);
          localStorage.setItem("refresh_token", token.refresh_token);
          return true;
        }
      } else {
        return false;
      }
    } catch (error) {
      console.log("error: ", error);
      return false;
    }
  };

  getList = (url) => {
    return new Promise((resolve, reject) => {
      axios
        .get(url, this.config())
        .then((response) => {
          resolve(response);
        })
        .catch(async (error) => {
          reject(error);
        });
    });
  };

  getPostList = (url, data) => {
    return new Promise((resolve, reject) => {
      axios.post(url, data, this.config()).
        then((response) => {
          resolve(response);
        }).catch(async (error) => {
          reject(error);
        })
    });
  }
  getPdf = (url) => {
    return new Promise((resolve, reject) => {
      axios
        .get(url, this.configPdf())
        .then((response) => {
          resolve(response);
        })
        .catch(async (error) => {
          reject(error);
        });
    });
  }

  getPostPdf = (url, data) => {
    return new Promise((resolve, reject) => {
      axios.post(url, data, this.configPdf()).
        then((response) => {
          resolve(response);
        }).catch(async (error) => {
          reject(error);
        })
    });
  }

  getDownload = (url, data) => {
    if (data) {
      return new Promise((resolve, reject) => {
        axios
          .post(url, data, this.configDownload())
          .then((response) => {
            resolve(response);
          })
          .catch(async (error) => {
            reject(error);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        axios
          .get(url, this.configDownload())
          .then((response) => {
            resolve(response);
          })
          .catch(async (error) => {
            reject(error);
          });
      });
    }
  };
  getDownloadPost = (url) => {
    return new Promise((resolve, reject) => {
      axios
        .post(url, this.configDownload())
        .then((response) => {
          resolve(response);
        })
        .catch(async (error) => {
          reject(error);
        });
    });

  };
  getEditData = (url, id, getValue) => {
    return new Promise((resolve, reject) => {
      if (getValue) {
        axios
          .get(`${url}/${id}/${getValue}`, this.config())
          .then((response) => {
            resolve(response);
          })
          .catch(async (error) => {
            reject(error);
          });
      } else {
        axios
          .get(`${url}/${id}`, this.config())
          .then((response) => {
            resolve(response);
          })
          .catch(async (error) => {
            reject(error);
          });
      }
    });
  };

  addData = (url, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(url, data, this.config())
        .then((response) => {
          // addDataCountries = (url, data) => {
          //     return new Promise((resolve, reject) => {
          //         axios.patch(url, data, this.config()).
          //             then((response) => {
          //                 resolve(response);
          //             }).catch(async (error) => {
          //                 reject(error);
          //             })
          //     });
          // }
          resolve(response);
        })
        .catch(async (error) => {
          reject(error);
        });
    });
  };

  addFiles = (url, data, uploadProgress) => {
    return new Promise((resolve, reject) => {
      axios
        .post(url, data, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "multipart/form-data",
          },
          maxBodyLength: Infinity,
          maxContentLength: Infinity,
          onUploadProgress: uploadProgress,
        })
        .then((resp) => resolve(resp))
        .catch((err) => reject(err));
    });
  };

  putData = (url, data) => {
    return new Promise((resolve, reject) => {
      axios
        .put(url, data, this.config())
        .then((response) => {
          resolve(response);
        })
        .catch(async (error) => {
          reject(error);
        });
    });
  };
  updatePutData = (url, id, data) => {
    return new Promise((resolve, reject) => {
      const path = id ? url + "/" + id : url;
      axios
        .put(path, data, this.config())
        .then((response) => {
          resolve(response);
        })
        .catch(async (error) => {
          reject(error);
        });
    });
  };
  updateData = (url, id, data) => {
    return new Promise((resolve, reject) => {
      const path = id ? url + "/" + id : url;
      axios
        .patch(path, data, this.config())
        .then((response) => {
          resolve(response);
        })
        .catch(async (error) => {
          reject(error);
        });
    });
  };
  patchData = (url, data) => {
    return new Promise((resolve, reject) => {
      axios
        .patch(url, data, this.config())
        .then((response) => {
          resolve(response);
        })
        .catch(async (error) => {
          reject(error);
        });
    });
  };
  deleteData = (url, id, data) => {
    return new Promise((resolve, reject) => {
      if (data) {
        const path = url;
        axios
          .delete(url, {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            data,
          })
          .then((response) => {
            resolve(response);
          })
          .catch(async (error) => {
            reject(error);
          });
      } else {
        axios
          .delete(url + "/" + id, this.config())
          .then((response) => {
            resolve(response);
          })
          .catch(async (error) => {
            reject(error);
          });
      }
    });
  };

  uploadFile = (url, formData) => {
    // const headers = new Headers();
    // headers.append("Content-Type" , "multipart/form-data");
    // headers.append("Content-Type" , "application/json");

    return new Promise((resolve, reject) => {
      axios(
        {
          method: "post",
          url: url,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
          },
          data: formData,
          // headers: headers,
          // headers: { "Content-Type" : "multipart/form-data"},
        },
        this.config()
      )
        .then((response) => {
          resolve(response);
        })
        .catch(async (error) => {
          reject(error);
        });
    });
  };

  updateUploadFile = (url, formData) => {
    return new Promise((resolve, reject) => {
      axios(
        {
          method: "put",
          url: url,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
          },
          data: formData,
          // headers: headers,
          // headers: { "Content-Type" : "multipart/form-data"},
        },
        this.config()
      )
        .then((response) => {
          resolve(response);
        })
        .catch(async (error) => {
          reject(error);
        });
    });
  };

  signInWithClientCredentials = async () => {
    try {
      console.log("Dashboard Auto-Login: Starting...");
      const clientId = process.env.REACT_APP_DASHBOARD_CLIENT_NAME;
      const clientSecret = process.env.REACT_APP_DASHBOARD_CLIENT_SECRET;
      if (!clientId || !clientSecret) {
        console.error("Missing Dashboard Client Credentials in .env");
        return false;
      }
      const encodedCredentials = window.btoa(`${clientId}:${clientSecret}`);
      const authHeader = `Basic ${encodedCredentials}`;
      const formData = new FormData();
      formData.append('grant_type', oAuthServiceConfig.grantTypeClientCredentials);
      formData.append('client_id', clientId);

      const response = await fetch(
        `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.token}`,
        {
          method: "POST",
          headers: {
            "Authorization": authHeader,
          },
          body: formData,
        }
      );

      if (response.status === 200) {
        const token = await response.json();
        if (token.access_token) {
          console.log("Dashboard Login Success!");
          localStorage.setItem("access_token", token.access_token);
          axios.defaults.headers.common['Authorization'] = `Bearer ${token.access_token}`;
          return true;
        }
      }

      console.error("Dashboard Login Failed. Status:", response.status);
      return false;

    } catch (error) {
      console.error("Dashboard Auto-Login Error:", error);
      return false;
    }
  };
}

const instance = new OAuthService();

export default instance;
